import { UnifiedLogger } from '@rbx/unified-logger';
import { getEventBasePath } from '@modules/utilities/constants/baseUrl';

export const PRODUCT_NAME = 'CreatorDocumentation';
const unifiedLoggerClient = new UnifiedLogger({
  eventBaseUrl: getEventBasePath(),
  product: PRODUCT_NAME,
  sessionProductGroup: 'CreatorHub',
});

export default unifiedLoggerClient;
